import React from "react";
import X from "./icons/X";

export default function ModalDefault({ onClose, title, children, id }) {

    const handleClose = onClose ?? (() => ({}));

    return (
        <>
            <div id={id} tabIndex="-1" aria-hidden="true" class="fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full bg-black bg-opacity-50">
                <div class="relative w-full max-w-2xl max-h-full mx-auto">
                    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <div class="flex items-start justify-between p-1 border-b border-gray-500 rounded-t dark:border-gray-600">
                            <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                                {title}
                            </h3>
                            <button type="button" onClick={handleClose} class="text-gray-400 bg-transparent hover:text-gray-100 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center" data-modal-hide="defaultModal">
                                <X />
                                <span class="sr-only">Close modal</span>
                            </button>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
}